import React, { useEffect, useState, useMemo, useRef } from "react";
import { Calendar as Cal, momentLocalizer } from "react-big-calendar";
import moment from "moment";

import axios from "axios";
import "react-big-calendar/lib/css/react-big-calendar.css";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Tooltip from "@mui/material/Tooltip";
import { useMsal } from "@azure/msal-react";
import { useBetween } from "use-between";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import { CircularProgress } from "@mui/material";
import {
  getFilteredHolidays,
  setupMomentLocalizer,
  isDateOnHoliday,
} from "../utils/datetimeutils";
import { acquireToken } from "../authentication/utils/authUtils";
import { Toolbar } from "./Toolbar";
import { fetchAllDataFromEndpoint } from "../utils/endpointutils";
import { useSharedFormState } from "../shared/sharedState";
import { filter } from "p-iteration";

const DragAndDropCalendar = withDragAndDrop(Cal);

const textstyle = {
  fontSize: "15px", // Adjust font size for better fit
  whiteSpace: "normal", // Ensure wrapping
  overflow: "hidden", // Hide overflow
  textOverflow: "ellipsis", // Add ellipsis if overflow
};

const filteredHolidays = getFilteredHolidays();
const localizer = setupMomentLocalizer();

export const Calendar = () => {
  const {
    eventsData,
    setEventsData,
    teamsData,
    setTeamsData,
    coachesData,
    setCoachesData,
    modifiedEvents,
    setModifiedEvents,
    deletedEvents,
    setDeletedEvents,
    schedulerAccount,
    setSchedulerAccount,
  } = useSharedFormState();

  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const [coachesLoading, setCoachesLoading] = useState(true);
  const [teamsLoading, setTeamsLoading] = useState(true);
  const [eventsLoading, setEventsLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [eventsResData, setEventsResData] = useState([]);
  const [removedCoaches, setRemovedCoaches] = useState(new Set());
  const [removedAdditionalParticipants, setRemovedAdditionalParticipants] =
    useState(new Set());

  const [coach, setCoach] = useState(new Map());
  const [additionalParticipants, setAdditionalParticipants] = useState(
    new Map()
  );

  const [stateStart, setStateStart] = useState(new Date());
  const [stateEnd, setStateEnd] = useState(new Date());
  const [title, setTitle] = useState("");

  const [team, setTeam] = useState("");
  const [teamId, setTeamId] = useState("");

  const [eventToEdit, setEventToEdit] = useState({
    start: new Date(),
    end: new Date(),
    title: "",
    coach: new Map(),
    additionalParticipants: new Map(),
    team: "",
    online: false,
    id: "",
  });
  const [onlineChecked, setOnlineChecked] = useState(false);

  const [deleteReccuringDialogOpen, setDeleteReccuringDialogOpen] =
    useState(false);
  const [focusedDialogOpen, setFocusedDialogOpen] = useState(false);
  const [sameTimeEvents, setSameTimeEvents] = useState([
    { id: 1, coach: new Map() },
  ]);
  const [loading, setLoading] = useState(true);

  const [options, setOptions] = useState([{}]); // To store fetched options
  const [isStudentsLoaded, setIsStudentsLoaded] = useState(false); // To track if data has been loaded
  const [studentsLoading, setStudentsLoading] = useState(true);
  const [laterEventsLoading, setLaterEventsLoading] = useState(true);
  const [laterEvents, setLaterEvents] = useState([]);

  const fetchOptions = async () => {
    setStudentsLoading(true);
    try {
      let token = await acquireToken(instance, account);
      let studentsRes = await fetchAllDataFromEndpoint("/api/students", {
        headers: {
          Authorization: token.accessToken,
        },
      });
      setOptions(studentsRes);
      setIsStudentsLoaded(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setStudentsLoading(false);
    }
  };

  const handleOpen = () => {
    if (!isStudentsLoaded) {
      fetchOptions();
    }
  };

  Date.prototype.withoutTime = function () {
    var d = new Date(this);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  function generateDistinctColors(count) {
    const colors = [];
    const hueStep = 360 / count;
    for (let i = 0; i < count; i++) {
      colors.push(`hsl(${Math.round(i * hueStep)}, 70%, 50%)`);
    }
    return colors;
  }

  useEffect(() => {
    async function getCoachesTeamsAndEvents() {
      let token = await acquireToken(instance, account);
      let start = moment().startOf("isoWeek").toISOString().slice(0, 16);
      let end = moment()
        .startOf("isoWeek")
        .add(1, "weeks")
        .toISOString()
        .slice(0, 16);
      let dataforevents = {
        start: start,
        end: end,
      };
      let eventsReq = axios.get("/api/eventstimeframe", {
        params: dataforevents,
        headers: {
          Authorization: token.accessToken,
        },
      });

      let coachReq = axios.get("/api/coaches", {
        headers: {
          Authorization: token.accessToken,
        },
      });
      let teamReq = axios.get("/api/teams", {
        headers: {
          Authorization: token.accessToken,
        },
      });
      let schedulerAccountReq = axios.get("/api/schedulerAccount", {
        headers: {
          Authorization: token.accessToken,
        },
      });

      const [coachRes, teamRes, eventsRes, schedulerAccountRes] =
        await Promise.all([coachReq, teamReq, eventsReq, schedulerAccountReq]);
      let coachDataMap = new Map();
      const coachResData = coachRes.data.res.value;
      const colors = generateDistinctColors(coachResData.length);
      let index = 0;
      coachResData.forEach((coachData) => {
        coachData.color = colors[index++];
        coachDataMap.set(coachData.mail, coachData);
      });
      let teamsDataMap = new Map();
      teamRes.data.res.value.forEach((team) => {
        teamsDataMap.set(team.id, team);
      });
      setSchedulerAccount(schedulerAccountRes.data.res);
      setCoachesData(coachDataMap);
      setTeamsData(teamsDataMap);
      setEventsResData(eventsRes.data.res.value);
      setCoachesLoading(false);
      setTeamsLoading(false);
      setEventsLoading(false);
    }
    getCoachesTeamsAndEvents();
  }, []);

  useEffect(() => {
    if (!coachesLoading && !teamsLoading && !eventsLoading) {
      processRawEvents(eventsResData);
    }
  }, [coachesLoading, teamsLoading, eventsLoading]);

  useEffect(() => {
    async function fetchFutureWeeksLater() {
      if (loading) {
        return;
      }
      let token = await acquireToken(instance, account);
      let start = moment()
        .startOf("isoWeek")
        .add(1, "weeks")
        .toISOString()
        .slice(0, 16);
      let dataforevents = {
        start: start,
      };
      let eventsReq = await fetchAllDataFromEndpoint("/api/eventsafterdate", {
        params: dataforevents,
        headers: {
          Authorization: token.accessToken,
        },
      });

      setLaterEvents(eventsReq);
      setLaterEventsLoading(false);
    }
    fetchFutureWeeksLater();
  }, [loading]);

  useEffect(() => {
    if (!laterEventsLoading) {
      processRawEvents(laterEvents);
    }
  }, [laterEventsLoading]);

  function processRawEvents(eventsResData) {
    let formattedEvents = eventsData;
    let removedCoach = new Set();

    eventsResData.forEach((event, idx) => {
      event.title = event.subject;
      event.participants = event.attendees;
      event.rawId = event.id;
      let additionalParticipants = new Map();
      if (!event.isCancelled) {
        let coachCount = 0;
        let coachParticipantsStatus = false;
        let coach = new Map();
        let participants = "";
        let coachParticipants = "";
        let start = new Date(event.start.dateTime + "Z");
        let end = new Date(event.end.dateTime + "Z");
        let title = event.title;
        console.log(event);
        let lastUnderscoreInId = event.transactionId.lastIndexOf("_");
        let id = event.transactionId.substring(0, lastUnderscoreInId);
        console.log("id");
        console.log(id);
        let teamId =
          event.transactionId != null
            ? event.transactionId.split("_").pop()
            : null;
        console.log(teamId);
        let transactionId = event.transactionId;
        let teamData;
        let team;
        let removedAdditionalParticipants = new Set();
        if (teamId != null) {
          teamData = teamsData.get(teamId);
          if (teamData != null) team = teamData.displayName;
        }
        let isRecurring =
          event.transactionId == null
            ? false
            : event.transactionId.includes("series");
        let online = false;
        let attendees = event.participants;
        let iCalUId = event.iCalUId;
        let organizer = event.organizer;
        let rawId = event.rawId;

        for (let i = 0; i < event.participants.length; i++) {
          let email = event.participants[i].emailAddress.address;
          let name = event.participants[i].emailAddress.name;
          if (coachesData.get(email) != null) {
            coach.set(email, name);
            coachCount += 1;
            if (coachParticipants.length > 0) {
              coachParticipants = coachParticipants + ", " + name;
            } else {
              coachParticipants = name;
            }
          } else {
            if (participants.length > 0) {
              participants = participants + ", " + name;
            } else {
              participants = name;
            }
          }
        }
        formattedEvents.set(id, {
          start,
          end,
          coach,
          title,
          id,
          team,
          isRecurring,
          online,
          participants,
          attendees,
          coachParticipantsStatus,
          iCalUId,
          rawId,
          teamId,
          organizer,
          transactionId,
          removedCoach,
          additionalParticipants,
          removedAdditionalParticipants,
        });
      }
    });
    setEventsData(new Map([...eventsData, ...formattedEvents]));
    setLoading(false);
  }

  const normalizeDate = (date) => {
    const normalized = new Date(date);
    normalized.setSeconds(0, 0);
    return normalized;
  };
  const isTimeOverlap = (start1, end1, start2, end2) => {
    return start1 < end2 && end1 > start2;
  };

  const hasCoachOverlap = (event1Coaches, event2Coaches) => {
    return Array.from(event1Coaches.keys()).some((coach) =>
      event2Coaches.has(coach)
    );
  };

  const isOverlap = (event) => {
    const eventsArray = Array.from(eventsData.values());
    for (const existingEvent of eventsArray) {
      if (existingEvent.id !== event.id) {
        const eventStart = normalizeDate(event.start);
        const eventEnd = normalizeDate(event.end);
        const existingStart = normalizeDate(existingEvent.start);
        const existingEnd = normalizeDate(existingEvent.end);
        if (isTimeOverlap(eventStart, eventEnd, existingStart, existingEnd)) {
          if (hasCoachOverlap(event.coach, existingEvent.coach)) {
            event.overlaps = true;
            return true;
          }
        }
      }
    }
    event.overlaps = false;
    return false;
  };

  const onEventDrop = ({ event, start, end, isAllDay }) => {
    const updatedEvent = { ...event, start, end, isAllDay };
    setEventsData((prev) => new Map(prev).set(event.id, updatedEvent));
    setModifiedEvents((prev) => new Map(prev).set(event.id, updatedEvent));
  };

  const customEvent = ({ event }) => {
    let coachMap = event.coach;
    let coachesString = "";
    Array.from(coachMap.values()).forEach((c) => {
      coachesString += c + ", ";
    });
    coachesString = coachesString.slice(0, -2);
    return (
      <div>
        <span style={textstyle}>
          {event.team}
          <br />
          {coachesString}
        </span>
      </div>
    );
  };

  const handleDialogSubmit = () => {
    setDialogOpen(false);
    let copiedModifiedEvents = new Map(modifiedEvents);
    var start = stateStart;
    var end = stateEnd;
    let iCalUId;

    let additionalParticipants = new Map();
    let removedCoach = new Set();
    let isFresh = true;
    var online = onlineChecked;
    let id = crypto.randomUUID();
    let copiedEventsData = new Map(eventsData);
    let eventobj = {
      start,
      end,
      title,
      id,
      coach,
      team,
      teamId,
      online,
      removedCoach,
      isFresh,
      iCalUId,
      additionalParticipants,
    };
    copiedEventsData.set(id, eventobj);
    copiedModifiedEvents.set(id, eventobj);
    setEventsData(copiedEventsData);
    setModifiedEvents(copiedModifiedEvents);
    setOnlineChecked(false);
  };

  const handleEditDialogSubmit = () => {
    Array.from(removedCoaches).forEach((c) => {
      if (eventToEdit.coach.get(c.mail) != null) {
        eventToEdit.removedCoach.add(c.mail);
      }
    });
    setRemovedCoaches([]);

    Array.from(removedAdditionalParticipants).forEach((p) => {
      if (
        eventToEdit.additionalParticipants.get(p.cr855_codersportsemail) != null
      ) {
        eventToEdit.removedAdditionalParticipants.add(p.cr855_codersportsemail);
      }
    });
    setRemovedAdditionalParticipants([]);
    eventToEdit.additionalParticipants = additionalParticipants;
    eventToEdit.title = title;
    eventToEdit.coach = coach;
    eventToEdit.team = team;
    eventToEdit.teamId = teamId;
    eventToEdit.online = onlineChecked;
    let copiedModifiedEvents = modifiedEvents;
    copiedModifiedEvents.set(eventToEdit.id, eventToEdit);
    setModifiedEvents(copiedModifiedEvents);

    setEditDialogOpen(false);
    setOnlineChecked(false);
  };

  const handleEditDialogRecurringChangeSubmit = () => {
    let tempcoachMap = new Map(eventToEdit.coach);
    eventToEdit.title = title;
    eventToEdit.coach = coach;
    eventToEdit.team = team;
    eventToEdit.teamId = teamId;
    eventToEdit.online = onlineChecked;
    var copiedEventsData = new Map(eventsData);
    var copiedModifiedEvents = new Map(modifiedEvents);
    Array.from(copiedEventsData.values()).forEach((event) => {
      if (
        event.id.toString().split("-")[0] === eventToEdit.id.split("-")[0] &&
        event.start >= eventToEdit.start
      ) {
        event.title = eventToEdit.title;
        event.coach = eventToEdit.coach;
        event.team = eventToEdit.team;
        event.online = eventToEdit.online;
        event.teamId = eventToEdit.teamId;
        event.additionalParticipants = additionalParticipants;
        Array.from(removedCoaches).forEach((c) => {
          if (tempcoachMap.get(c.mail) != null) {
            event.removedCoach.add(c.mail);
          }
        });

        if (removedCoaches.size == 0) {
          event.removedCoach = new Set();
        }
        setRemovedCoaches(new Set());
        copiedModifiedEvents.set(event.id, event);
      }
    });

    setModifiedEvents(copiedModifiedEvents);

    setEventsData(copiedEventsData);
    setEditDialogOpen(false);
    setOnlineChecked(false);
  };

  const handleEditDialogDelete = (bypass) => {
    if (bypass || !eventToEdit.isRecurring) {
      let eventToDelete = eventsData.get(eventToEdit.id);

      setDeletedEvents([...deletedEvents, eventToDelete]);
      let copiedEventsData = new Map(eventsData);
      copiedEventsData.delete(eventToEdit.id);
      setEventsData(copiedEventsData);
      setEditDialogOpen(false);
      if (bypass) {
        setDeleteReccuringDialogOpen(false);
      }
    } else {
      setEditDialogOpen(false);
      handleDeleteReccuringDialogOpen();
    }
  };

  const handleEditDialogOpen = (event) => {
    setCoach(event.coach);
    setAdditionalParticipants(event.additionalParticipants);
    setTeam(event.team);
    setTeamId(event.teamId);
    setTitle(event.title);
    setOnlineChecked(event.online);
    setEventToEdit(event);
    setEditDialogOpen(true);
  };

  const handleFocusedDialogOpen = (event) => {
    setEditDialogOpen(false);
    var copyarr = [];
    copyarr.push(event);
    let eventsdataArr = Array.from(eventsData.values());
    for (let i in eventsdataArr) {
      if (eventsdataArr[i].id != event.id) {
        let eventdatastart = new Date(eventsdataArr[i].start);
        let eventstart = new Date(event.start);
        eventstart.setSeconds(0, 0);
        eventdatastart.setSeconds(0, 0);
        let eventdataend = new Date(eventsdataArr[i].end);
        let eventend = new Date(event.end);
        eventend.setSeconds(0, 0);
        eventdataend.setSeconds(0, 0);
        if (eventstart < eventdataend && eventend > eventdatastart) {
          copyarr.push(eventsdataArr[i]);
        }
      }
    }

    setSameTimeEvents(copyarr);

    setFocusedDialogOpen(true);
  };

  const handleSelect = ({ start, end }) => {
    setStateStart(start);
    setStateEnd(end);
    setDialogOpen(true);
  };

  const handleOnlineCheckedChange = () => {
    setOnlineChecked(!onlineChecked);
  };
  async function handleClick(event, e) {
    handleFocusedDialogOpen(event);
  }

  const handleDeleteReccuringDialogOpen = () => {
    setDeleteReccuringDialogOpen(true);
  };

  const handleDeleteReccuringDialogClose = () => {
    setDeleteReccuringDialogOpen(false);
  };

  const handleDeleteReccuringDialogCloseSeries = () => {
    let eventsToDelete = [];
    let eventsarr = Array.from(eventsData.values());
    let copiedEventsData = new Map(eventsData);
    eventsarr.forEach((event) => {
      if (
        event.id.toString().split("-")[0] === eventToEdit.id.split("-")[0] &&
        event.start >= eventToEdit.start
      ) {
        eventsToDelete.push(event);
        copiedEventsData.delete(event.id);
      }
    });
    setEventsData(copiedEventsData);
    setDeletedEvents([...deletedEvents, ...eventsToDelete]);
    setDeleteReccuringDialogOpen(false);
  };

  const handlePaperClick = (event) => {
    setFocusedDialogOpen(false);
    handleEditDialogOpen(event);
  };

  let sameTimeMap = sameTimeEvents.map((event) => {
    if (event.start == null) {
      event.start = new Date();
    }
    if (event.end == null) {
      event.end = new Date();
    }
    let coachMap = event.coach;
    let coachesString = "";
    Array.from(coachMap.values()).forEach((c) => (coachesString += c + ","));
    coachesString = coachesString.slice(0, -1);

    return (
      <Grid style={{ textAlign: "center" }} item xs={12}>
        <Paper
          onClick={() => handlePaperClick(event)}
          style={{
            cursor: "pointer",
            backgroundColor:
              event.coach.size == 1
                ? coachesData.get(event.coach.entries().next().value[0]).color
                : "green",
            color: "white",
          }}
          variant="elevation"
        >
          <span>{event.title}</span>
          <br />
          <span>Coach: {coachesString}</span>
          <br />
          <span>Team: {event.team}</span>
          <br />
          <span>
            Time:{" "}
            {moment(event.start.toString().slice(16, 21), "hh:mm").format(
              "hh:mm"
            )}{" "}
            -{" "}
            {moment(event.end.toString().slice(16, 21), "hh:mm").format(
              "hh:mm"
            )}
          </span>
          <br />
          <span>{event.online ? "Online" : "In Person"}</span>
        </Paper>
      </Grid>
    );
  });

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          minHeight: "100vh",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress size="20vh" />
      </div>
    );
  } else {
    return (
      <div className="App">
        <DragAndDropCalendar
          defaultView="week"
          selectable
          localizer={localizer}
          defaultDate={new Date()}
          events={eventsData}
          style={{ height: "100vh" }}
          onSelectEvent={(event, e) => handleClick(event, e)}
          onSelectSlot={handleSelect}
          onEventResize={onEventDrop}
          onEventDrop={onEventDrop}
          resizable
          components={{
            event: customEvent,
            toolbar: Toolbar,
          }}
          dayLayoutAlgorithm="no-overlap"
          min={new Date(0, 0, 0, 9, 0, 0)}
          max={new Date(0, 0, 0, 22, 0, 0)}
          eventPropGetter={(event) => ({
            style: {
              backgroundColor:
                isOverlap(event) ||
                isDateOnHoliday(event.start, filteredHolidays)
                  ? "red"
                  : event.coach.size == 1
                  ? coachesData.get(event.coach.entries().next().value[0]).color
                  : "green",
            },
          })}
        />
        <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
          <DialogTitle>Create a meeting</DialogTitle>
          <DialogContent>
            <TextField
              onChange={(e) => setTitle(e.target.value)}
              margin="dense"
              label="Meeting Title"
            />

            <Autocomplete
              multiple
              id="combo-box-demo"
              options={Array.from(coachesData.values()) ?? []}
              getOptionLabel={(option) => option.displayName || ""}
              renderOption={(props, option) => {
                return (
                  <div>
                    <Tooltip placement="left" title={option.mail}>
                      <Button
                        sx={{ textTransform: "none" }}
                        component="li"
                        {...props}
                        fullWidth
                      >
                        {props.key}
                      </Button>
                    </Tooltip>
                  </div>
                );
              }}
              onChange={(e, v) => {
                let coachMap = new Map();
                v.forEach((c) => {
                  coachMap.set(c.mail, c.displayName);
                });
                setCoach(coachMap);
              }}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField margin="dense" {...params} label="Coach" />
              )}
            />
            <Autocomplete
              id="combo-box-demo1"
              options={Array.from(teamsData.values()) ?? []}
              getOptionLabel={(option) => option.displayName || ""}
              onChange={(e, v) => {
                setTeam(v.displayName);
                setTeamId(v.id);
              }}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField margin="dense" {...params} label="Team" />
              )}
            />

            <FormControlLabel
              value="start"
              control={
                <Checkbox
                  checked={onlineChecked}
                  onChange={handleOnlineCheckedChange}
                />
              }
              label="Online"
              labelPlacement="end"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
            <Button onClick={handleDialogSubmit}>Create</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)}>
          <DialogTitle>
            Edit this meeting
            <Button
              onClick={() => handleFocusedDialogOpen(eventToEdit)}
              style={{ marginLeft: "10px" }}
              variant="contained"
            >
              See timeslot details
            </Button>
          </DialogTitle>
          <DialogContent>
            <TextField
              defaultValue={eventToEdit.title}
              onChange={(e) => setTitle(e.target.value)}
              margin="dense"
              label="Meeting Title"
            />
            <Autocomplete
              multiple
              id="combo-box-demo"
              options={Array.from(coachesData.values()) ?? []}
              getOptionLabel={(option) => option.displayName || ""}
              defaultValue={Array.from(eventToEdit.coach.keys()).map((k) =>
                coachesData.get(k)
              )}
              renderOption={(props, option) => {
                return (
                  <div>
                    <Tooltip placement="left" title={option.mail}>
                      <Button
                        sx={{ textTransform: "none" }}
                        component="li"
                        {...props}
                        fullWidth
                      >
                        {props.key}
                      </Button>
                    </Tooltip>
                  </div>
                );
              }}
              onChange={(e, v, reason, detail) => {
                let removedCoachesCopy = new Set(removedCoaches);
                if (reason === "removeOption") {
                  removedCoachesCopy.add(detail.option);
                }
                let coachMap = new Map();
                v.forEach((c) => {
                  coachMap.set(c.mail, c.displayName);
                  removedCoachesCopy.delete(c);
                });
                setRemovedCoaches(removedCoachesCopy);

                setCoach(coachMap);
              }}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField margin="dense" {...params} label="Coaches" />
              )}
            />
            <Autocomplete
              disabled={true}
              id="combo-box-demo1"
              options={Array.from(teamsData.values()) ?? []}
              getOptionLabel={(option) => option.displayName || ""}
              onChange={(e, v) => {
                setTeam(v.displayName);
                setTeamId(v.id);
              }}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField
                  margin="dense"
                  {...params}
                  label={eventToEdit.team}
                />
              )}
            />
            <Autocomplete
              multiple
              id="combo-box-demo"
              options={options}
              loading={studentsLoading}
              onOpen={handleOpen}
              getOptionLabel={(option) => option.fullname || ""}
              renderOption={(props, option) => {
                return (
                  <div>
                    <Tooltip placement="left" title={option.mail}>
                      <Button
                        sx={{ textTransform: "none" }}
                        component="li"
                        {...props}
                        fullWidth
                      >
                        {props.key}
                      </Button>
                    </Tooltip>
                  </div>
                );
              }}
              onChange={(e, v, reason, detail) => {
                let removedAdditionalParticipantsCopy = new Set(
                  removedAdditionalParticipants
                );
                if (reason === "removeOption") {
                  removedAdditionalParticipantsCopy.add(detail.option);
                }

                let additionalParticipantsMap = new Map();
                v.forEach((p) => {
                  additionalParticipantsMap.set(
                    p.cr855_codersportsemail,
                    p.fullname
                  );
                  removedAdditionalParticipantsCopy.delete(p);
                });
                setRemovedAdditionalParticipants(
                  removedAdditionalParticipantsCopy
                );
                setAdditionalParticipants(additionalParticipantsMap);
              }}
              sx={{
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#000000",
                },
                width: 300,
              }}
              renderInput={(params) => (
                <TextField
                  margin="dense"
                  {...params}
                  label="Add additional student"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {studentsLoading ? (
                          <CircularProgress size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
            <Autocomplete
              multiple
              disabled={true}
              id="combo-box-demo"
              defaultValue={eventToEdit.attendees || []}
              options={eventToEdit.attendees | []}
              getOptionLabel={(option) => option.emailAddress.name || ""}
              renderOption={(props, option) => {
                return (
                  <div>
                    <Tooltip placement="left" title={option.mail}>
                      <Button
                        sx={{ textTransform: "none" }}
                        component="li"
                        {...props}
                        fullWidth
                      >
                        {props.key}
                      </Button>
                    </Tooltip>
                  </div>
                );
              }}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField
                  margin="dense"
                  {...params}
                  label="All Participants"
                />
              )}
            />
            <FormControlLabel
              value="start"
              control={
                <Checkbox
                  checked={onlineChecked}
                  onChange={handleOnlineCheckedChange}
                />
              }
              label="Online"
              labelPlacement="end"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEditDialogOpen(false)}>Cancel</Button>
            <Button
              onClick={() => {
                handleEditDialogDelete(false);
              }}
            >
              Delete
            </Button>
            <Button onClick={handleEditDialogSubmit}>Modify</Button>
            <Button
              disabled={!eventToEdit.id.toString().includes("series")}
              onClick={handleEditDialogRecurringChangeSubmit}
            >
              Modify Series
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={deleteReccuringDialogOpen}
          onClose={handleDeleteReccuringDialogClose}
        >
          <DialogTitle>Delete Series or Instance</DialogTitle>
          <DialogActions>
            <Button
              onClick={() => {
                handleEditDialogDelete(true);
              }}
            >
              Instance
            </Button>
            <Button onClick={handleDeleteReccuringDialogCloseSeries}>
              Series
            </Button>
            <Button onClick={handleDeleteReccuringDialogClose}>Cancel</Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={focusedDialogOpen}
          onClose={() => setFocusedDialogOpen(false)}
        >
          <DialogTitle>Overlapping Events</DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              {sameTimeMap}
            </Grid>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
};
